export default "__VITE_ASSET__DHu60M7L__"